import { render, staticRenderFns } from "./OrdersScheduleBeauty.vue?vue&type=template&id=039cbdd8&scoped=true"
import script from "./OrdersScheduleBeauty.vue?vue&type=script&lang=js"
export * from "./OrdersScheduleBeauty.vue?vue&type=script&lang=js"
import style0 from "./OrdersScheduleBeauty.vue?vue&type=style&index=0&id=039cbdd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039cbdd8",
  null
  
)

export default component.exports